/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'product-category-list';
class ProductCategoryList extends Component {
    elements = {
        mobileDropdown: this.element.querySelector(`.${componentName}__list-mobile-details`),
        summary: this.element.querySelector(`.${componentName}__list-mobile-details > summary`),
    };

    addEventListeners = () => {
        document.addEventListener('click', () => {
            this.elements.mobileDropdown.removeAttribute('open');
        });

        this.elements.mobileDropdown.addEventListener('click', (ev) => {
            ev.stopPropogation();
        });

        if (this.elements.summary) {
            this.elements.summary.addEventListener('click', (event) => {
                event.preventDefault(); // prevent native toggle behavior
                event.stopPropagation(); // prevent closing from document listener

                const isOpen = this.elements.mobileDropdown.hasAttribute('open');
                if (isOpen) {
                    this.elements.mobileDropdown.removeAttribute('open');
                } else {
                    this.elements.mobileDropdown.setAttribute('open', '');
                }
            });
        }

    };

    /**
     * Initialize Component
     */
    init = () => {
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, ProductCategoryList);
